
import SubTituloSimp from "./../../components/atoms/subTitles/SubTituloSimp";
import React, { useState } from "react";
import Header from "./../../components/molecules/header/Header";
import { useEffect } from "react";
import Titulo from "../../components/atoms/titles/Titulo";
import "./detallePersonal.css";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
import CambioPasswd from "../../components/molecules/modals/cambioPasswd/CambioPasswd";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom";
import { getDatosIhPersona } from "../../components/services/IhPersonaService";

const DetallePersonal = () => {

  // agregar al user details al loguearte que devuelva la letra inicial del dni si tiene
  const [user] = useLocalStorage("user", "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [datosIhPersona, setDatosIhPersona] = useState();
  const navigate = useNavigate();
  // const handleShow = () => {
  //   setShowPass(!showPass);
  //   
  // };

  const handleClose = (e) => {
    setShowPass(false);
  };

  useEffect(() => {
    if (user !== undefined) {
      if (user.niep !== undefined) {
        setLoading(true);
      } else {
        setError(true);
      }
    }
  }, [user]);

  useEffect(() => {
    getDatosIhPersona().then((data) => {
      
      setDatosIhPersona(data);
    } ).catch((err) => {
      // console.error("Error al obtener los datos IH Persona: ", err);
    }); 
  }, []);
  return (
    <>
      <Header></Header>
      {loading ? (
        <>
          <div className="container vh-100" role="main" data-landmark-index="4">
            <div className="caja_media caja_picada caja col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 pb-3">
              <Titulo
                tipo={"tituloModal"}
                titulo={"Datos Personales"}
                clasesHijo={"fs-3"}
              />

              <div className="container container-fluid">
                <div className=" col-lg-12 col-md-12 col-xs-12">
                  <div className="row justify-content-around col-lg-12 col-md-12 col-xs-12">
                    {/* DNI*/}
                    <div className="form-group col-lg-6 col-md-6 col-xs-12 ">
                      <div className="form-group col-lg-12 col-md-12 col-xs-12">
                        <label className="col-12">
                          <div className="row justify-content-around">
                            <SubTituloSimp nombre="DNI" />
                          </div>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            id="dni"
                            className="form-control form-group"
                            name="dni"
                            value={
                              user?.niep ? 
                                datosIhPersona?.letiniiep ? `${datosIhPersona?.letiniiep}${user?.niep}${user?.letniep}` : `${user?.niep}${user?.letniep}`
                              : ""
                            }
                            disabled
                          />
                        </div>
                      </div>
                      {/* nombre */}
                      <div className="form-group col-lg-12 col-md-12 col-xs-12">
                        <label className="col-12">
                          <div className="row justify-content-around">
                            <SubTituloSimp nombre="Nombre" />
                          </div>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            id="nombre"
                            className="form-control form-group"
                            name="nombre"
                            value={user?.nombre ? user?.nombre : ""}
                            disabled
                          />
                        </div>
                      </div>
                      {/* Apellido 1 */}
                      <div className="form-group col-lg-12 col-md-12 col-xs-12 ">
                        <label className="col-12">
                          <div className="row justify-content-around">
                            <SubTituloSimp nombre="Apellido 1" />
                          </div>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            id="apellido1"
                            className="form-control form-group"
                            name="apellido1"
                            value={user?.apellido1 ? user?.apellido1 : ""}
                            disabled
                          />
                        </div>
                      </div>
                      {/* Apellido 2 */}
                      <div className="form-group col-lg-12 col-md-12 col-xs-12 ">
                        <label className="col-12">
                          <div className="row justify-content-around">
                            <SubTituloSimp nombre="Apellido 2" />
                          </div>
                        </label>
                        <div className="">
                          <input
                            type="text"
                            id="apellido2"
                            className="form-control form-group"
                            name="apellido2"
                            value={user?.apellido2 ? user?.apellido2 : ""}
                            disabled
                          />

                        </div>
                      </div>

                    </div>
                  </div>
                </div>

              </div>
              <div className="d-flex justify-content-center pt-3 row align-items-center">
                <div className="col-md-3 order-1 order-md-0">
                  <button
                    type="button"
                    className=" btnRed rounded mt-3 botonVolverDetallePersonal"
                    onClick={() => navigate("/home")}
                  >
                    <i className="fa-solid fa-rotate-left px-2"></i> Volver
                  </button>
                </div>
                {/* <div className="col-md-3 order-0 order-md-1">
                  <button
                  type="button"
                  className="btn rounded mt-3"
                  onClick={() => handleShow()}
                >
                  <i className="fa-solid fa-key px-2"></i> Cambiar contraseña
                </button>
                </div> */}
                



              </div>

            </div>
          </div>
          {showPass ? (
            <>

              <CambioPasswd
                show={showPass}
                handleClose={handleClose}
                titulo="Error al recuperar el PDF"
                tipo="tituloBorrador rojo"
              ></CambioPasswd>
            </>
          ) : null}
        </>
      ) : error ? (
        <>
          <IfError
            mensage="Error: No se han podido cargar los datos del usuario."
            ruta="/home"
          ></IfError>
          <div className="vh-100"></div>
        </>
      ) : (
        <>
          <SpinnerCircle></SpinnerCircle>
          <div className="vh-100"></div>
        </>
      )}
      <Footer></Footer>
    </>
  );
};

export default DetallePersonal;
